module.exports = __webpack_public_path__ + "fonts/Montserrat-BoldItalic.360c843.ttf";